import React, { Component } from 'react'

export default class GlobalLoader extends Component {
    render () {
        return (
            <div></div>
        )
    }
}